import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function HomePage() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isEnglishPage = location.pathname.startsWith('/en');

  useEffect(() => {
    // Dile göre sayfa başlığını ayarla
    if (isEnglishPage) {
      document.title = 'AJAN LASER - Fiber Laser Cutting Machine';
    } else {
      document.title = 'AJAN LAZER - Fiber Lazer Kesim Makinesi';
    }

    // Hero görselini preload et - DİLE GÖRE AYRILMIŞ GÖRSELLER
    const heroImage = new Image();
    if (isEnglishPage) {
      heroImage.src = "https://ajancnc.com/wp-content/uploads/2025/12/ajanlaser-1.png";
    } else {
      heroImage.src = "https://files.ajancnc.com/wp-content/uploads/2025/12/ajan-lazer-1.png";
    }
  }, [isEnglishPage]);

  const [activeProduct, setActiveProduct] = useState('kapali-kabin');
  const [showKapaliSpecs, setShowKapaliSpecs] = useState(true);
  const [showGezerSpecs, setShowGezerSpecs] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [messageError, setMessageError] = useState('');

  // Check if current path is English version
  const isEnglish = i18n.language === 'en';

  // Scroll event listener for scroll-to-top button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleCatalogClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE(isEnglish ? '/en/catalog' : '/katalog');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // Ürünler verisi
  const products = [
    {
      id: 'kapali-kabin',
      name: isEnglish ? 'Fully Enclosed Fiber Laser' : 'Kapalı Kabin Fiber Lazer',
      desc: isEnglish 
        ? 'Safe and quiet laser cutting solutions with fully enclosed working area'
        : 'Güvenli ve hassas seri üretim için tam kapalı sistem',
      image: 'http://files.ajanlazer.com/wp-content/uploads/2025/12/ajanlaser.logo_.png',
      specs: [
        { label: isEnglish ? 'Working Area:' : 'Çalışma Alanı:', value: isEnglish ? 'Various size options' : 'Farklı ebat seçenekleri' },
        { label: isEnglish ? 'Power Unit:' : 'Güç Ünitesi:', value: isEnglish ? '3–20 kW Fiber Laser' : '3–20 kW Fiber Lazer' },
        { label: isEnglish ? 'Cabin Structure:' : 'Kabin Yapısı:', value: isEnglish ? 'Fully Enclosed' : 'Tam Kapalı' },
        { label: isEnglish ? 'Advantage:' : 'Avantaj:', value: isEnglish ? 'Safe and precise serial production' : 'Güvenli ve hassas seri üretim' }
      ]
    },
    {
      id: 'gezer-kabin',
      name: isEnglish ? 'Enclosed Gantry Fiber Laser' : 'Gezer Kabin Fiber Lazer',
      desc: isEnglish 
        ? 'Flexible cutting capability in large areas with mobile cabin system'
        : 'Geniş alanlarda esnek üretim için hareketli kabin',
      image: 'http://files.ajanlazer.com/wp-content/uploads/2025/12/gezer_kabin_fonsuz.png',
      specs: [
        { label: isEnglish ? 'Working Area:' : 'Çalışma Alanı:', value: isEnglish ? 'Large sheet metal cutting' : 'Büyük ebat sac kesimi' },
        { label: isEnglish ? 'Power Unit:' : 'Güç Ünitesi:', value: isEnglish ? '6–20 kW Fiber Laser' : '6–20 kW Fiber Lazer' },
        { label: isEnglish ? 'System:' : 'Sistem:', value: isEnglish ? 'Mobile Cabin Structure' : 'Hareketli Kabin Yapısı' },
        { label: isEnglish ? 'Advantage:' : 'Avantaj:', value: isEnglish ? 'Flexible production in large areas' : 'Geniş alanlarda esnek üretim' }
      ]
    },
    {
      id: 'boru-profil-kesim',
      name: isEnglish ? 'Tube and Profile Fiber Laser' : 'Boru ve Profil Fiber Lazer',
      desc: isEnglish 
        ? 'Advanced laser systems specially designed for tube and profile cutting'
        : 'Çoklu boru ve profil uyumu için özel tasarım',
      image: 'https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/f498853daf2316de5fdcd5614fb9835f.png',
      specs: [
        { label: isEnglish ? 'Cutting Capacity:' : 'Kesme Kapasitesi:', value: 'Ø 20–360 mm' },
        { label: isEnglish ? 'Cutting Length:' : 'Kesme Uzunluğu:', value: '6000 / 12000 mm' },
        { label: isEnglish ? 'Power Unit:' : 'Güç Ünitesi:', value: isEnglish ? '3–6 kW Fiber Laser' : '3–6 kW Fiber Lazer' },
        { label: isEnglish ? 'Advantage:' : 'Avantaj:', value: isEnglish ? 'Multiple tube and profile compatibility' : 'Çoklu boru ve profil uyumu' }
      ]
    }
  ];

  const handleProductClick = (productId: string) => {
    window.REACT_APP_NAVIGATE(isEnglish ? `/en/products/${productId}` : `/products/${productId}`);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // Change language based on URL
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/en')) {
      i18n.changeLanguage('en');
    } else {
      i18n.changeLanguage('tr');
    }
  }, [i18n]);

  // Kapalı Kabin özellikleri butonuna tıklandığında
  const handleKapaliSpecsToggle = () => {
    const newState = !showKapaliSpecs;
    setShowKapaliSpecs(newState);
    
    if (newState) {
      // Özellikleri aç ve sayfayı kaydır
      setTimeout(() => {
        const specsSection = document.querySelector('#kapali-specs-section');
        if (specsSection) {
          const yOffset = -100;
          const y = specsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 150);
    }
  };

  // Gezer Kabin özellikleri butonuna tıklandığında
  const handleGezerSpecsToggle = () => {
    const newState = !showGezerSpecs;
    setShowGezerSpecs(newState);
    
    if (newState) {
      // Özellikleri aç ve sayfayı kaydır
      setTimeout(() => {
        const specsSection = document.querySelector('#gezer-specs-section');
        if (specsSection) {
          const yOffset = -100;
          const y = specsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 150);
    }
  };

  const features = [
    {
      icon: 'ri-speed-line',
      title: t('nav.features'),
      description: t('features.speedDesc')
    },
    {
      icon: 'ri-tools-line',
      title: t('features.domesticProduction'),
      description: t('features.domesticProductionDesc')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('features.serviceNetwork'),
      description: t('features.serviceNetworkDesc')
    },
    {
      icon: 'ri-settings-3-line',
      title: t('features.easyToUse'),
      description: t('features.easyToUseDesc')
    }
  ];

  const whyChooseUs = [
    {
      title: t('why.reliableTech'),
      description: t('why.reliableTechDesc')
    },
    {
      title: t('why.affordableCost'),
      description: t('why.affordableCostDesc')
    },
    {
      title: t('why.continuousInnovation'),
      description: t('why.continuousInnovationDesc')
    },
    {
      title: t('why.customerFocused'),
      description: t('why.customerFocusedDesc')
    }
  ];

  const kapaliKabinSpecs = [
    {
      id: 1,
      title: t('specs.laserPower'),
      value: '3KW / 6KW / 12KW / 20KW',
      icon: 'ri-flashlight-line'
    },
    {
      id: 2,
      title: t('specs.zAxisHeight'),
      value: '320 mm',
      icon: 'ri-arrow-up-down-line'
    },
    {
      id: 3,
      title: t('specs.xyPositionAccuracy'),
      value: '±0.03 mm',
      icon: 'ri-focus-3-line'
    },
    {
      id: 4,
      title: t('specs.xyRepeatAccuracy'),
      value: '±0.02 mm',
      icon: 'ri-repeat-line'
    },
    {
      id: 5,
      title: t('specs.xyMaxSpeed'),
      value: t('specs.xyMaxSpeedValue'),
      icon: 'ri-speed-line'
    },
    {
      id: 6,
      title: t('specs.xyMaxAcceleration'),
      value: '1,5 G',
      icon: 'ri-rocket-line'
    },
    {
      id: 7,
      title: t('specs.laserSource'),
      value: 'RECİ',
      icon: 'ri-lightbulb-flash-line'
    },
    {
      id: 8,
      title: t('specs.laserHead'),
      value: 'BOCHU Autofocus',
      icon: 'ri-focus-2-line'
    },
    {
      id: 9,
      title: t('specs.body'),
      value: t('specs.bodyValue'),
      icon: 'ri-building-line'
    },
    {
      id: 10,
      title: t('specs.xyRail'),
      value: 'HIWIN',
      icon: 'ri-ruler-line'
    },
    {
      id: 11,
      title: t('specs.xyRack'),
      value: t('specs.xyRackValue'),
      icon: 'ri-settings-4-line'
    },
    {
      id: 12,
      title: t('specs.servoMotors'),
      value: 'Delta',
      icon: 'ri-cpu-line'
    },
    {
      id: 13,
      title: t('specs.reducer'),
      value: 'Techmech',
      icon: 'ri-settings-3-line'
    },
    {
      id: 14,
      title: t('specs.electricalComponents'),
      value: 'Schneider, Omron',
      icon: 'ri-plug-line'
    },
    {
      id: 15,
      title: t('specs.lubricationSystem'),
      value: t('specs.lubricationSystemValue'),
      icon: 'ri-drop-line'
    },
    {
      id: 16,
      title: t('specs.chiller'),
      value: 'TEYU S&A',
      icon: 'ri-temp-cold-line'
    },
    {
      id: 17,
      title: t('specs.pneumaticComponents'),
      value: 'Airtac',
      icon: 'ri-tools-line'
    },
    {
      id: 18,
      title: t('specs.cncControl'),
      value: 'FSCUT',
      icon: 'ri-computer-line'
    }
  ];

  const gezerKabinSpecs = [
    {
      icon: 'ri-flashlight-line',
      title: t('specs.laserPower'),
      value: '3KW / 6KW / 12KW / 20KW'
    },
    {
      icon: 'ri-arrow-up-down-line',
      title: t('specs.zAxisHeight'),
      value: '320 mm'
    },
    {
      icon: 'ri-focus-3-line',
      title: t('specs.xyPositionAccuracy'),
      value: '±0.03 mm'
    },
    {
      icon: 'ri-repeat-line',
      title: t('specs.xyRepeatAccuracy'),
      value: '±0.02 mm'
    },
    {
      icon: 'ri-speed-line',
      title: t('specs.xyMaxSpeedIdle'),
      value: t('specs.xyMaxSpeedIdleValue'),
    },
    {
      icon: 'ri-rocket-line',
      title: t('specs.xyMaxAcceleration'),
      value: '0,8 G'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: t('specs.laserSource'),
      value: 'RECİ'
    },
    {
      icon: 'ri-focus-2-line',
      title: t('specs.laserHead'),
      value: 'BOCİ Autofocus'
    },
    {
      icon: 'ri-building-line',
      title: t('specs.body'),
      value: t('specs.bodyValue')
    },
    {
      icon: 'ri-ruler-line',
      title: t('specs.xyRail'),
      value: 'HIWIN'
    },
    {
      icon: 'ri-settings-4-line',
      title: t('specs.xyRack'),
      value: t('specs.xyRackValue')
    },
    {
      icon: 'ri-cpu-line',
      title: t('specs.servoMotors'),
      value: 'Delta'
    },
    {
      icon: 'ri-settings-3-line',
      title: t('specs.reducer'),
      value: 'Techmech'
    },
    {
      icon: 'ri-plug-line',
      title: t('specs.electricalComponents'),
      value: 'Schneider, Omron'
    },
    {
      icon: 'ri-drop-line',
      title: t('specs.lubricationSystem'),
      value: t('specs.lubricationSystemValue')
    },
    {
      icon: 'ri-temp-cold-line',
      title: t('specs.chiller'),
      value: 'TEYU S&A'
    },
    {
      icon: 'ri-tools-line',
      title: t('specs.pneumaticComponents'),
      value: 'Airtac'
    },
    {
      icon: 'ri-computer-line',
      title: t('specs.cncControl'),
      value: 'FSCUT'
    }
  ];

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Mesaj zorunlu ve minimum 10 karakter kontrolü
    if (!formData.message || formData.message.trim().length < 10) {
      setMessageError(
        isEnglish
          ? 'Message is required and must be at least 10 characters.'
          : 'Mesaj alanı zorunludur ve en az 10 karakter olmalıdır.'
      );
      return;
    }
    setMessageError('');

    // Mesaj karakter kontrolü
    if (formData.message.length > 500) {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
      return;
    }
    
    setFormStatus('submitting');

    try {
      const SUPABASE_URL = 'https://luyljiplvccnduaobqqu.supabase.co';
      const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx1eWxqaXBsdmNjbmR1YW9icXF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ5MDM5NjUsImV4cCI6MjA4MDQ3OTk2NX0.WOByVi5d5oVfPZcecR1T35wPyhBySC-6PZQLqBW1vlQ';

      // Dile göre doğru Edge Function'ı seç - slug formatında (URL'e göre - daha güvenilir)
      const functionSlug = isEnglishPage ? 'send-contact-email-en' : 'send-contact-email-tr';
      const functionUrl = `${SUPABASE_URL}/functions/v1/${functionSlug}`;
      const supabaseAnonKey = SUPABASE_ANON_KEY;

      console.log('Form gönderiliyor:', functionUrl);
      console.log('Form verisi:', formData);

      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${supabaseAnonKey}`,
        },
        body: JSON.stringify({
          company: formData.company || '',
          name: formData.name || '',
          email: formData.email || '',
          phone: formData.phone || '',
          address: formData.address || '',
          message: formData.message || '',
          website: (document.querySelector('input[name="website"]') as HTMLInputElement)?.value || ''
        }),
      });

      console.log('Yanıt durumu:', response.status);
      
      const responseText = await response.text();
      console.log('Yanıt metni:', responseText);

      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (parseError) {
        console.error('JSON parse hatası:', parseError);
        console.error('Ham yanıt:', responseText);
        throw new Error('Sunucudan geçersiz yanıt alındı');
      }

      console.log('Yanıt verisi:', responseData);

      if (!response.ok) {
        console.error('Edge Function hatası:', responseData);
        throw new Error(responseData.error || 'Form gönderilemedi');
      }

      setFormStatus('success');
      setFormData({
        company: '',
        name: '',
        email: '',
        phone: '',
        address: '',
        message: ''
      });
      setTimeout(() => setFormStatus('idle'), 5000);

    } catch (error) {
      console.error('Form gönderim hatası:', error);
      console.error('Hata detayı:', error instanceof Error ? error.message : 'Bilinmeyen hata');
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -80;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header - Sabit Üstte */}
      <Header />

      {/* Hero Section - Premium Endüstriyel Sahne */}
      <section className="relative w-full h-[80vh] overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
        {/* Arka Plan - AJAN Logo Görseli - DİLE GÖRE AYRILMIŞ GÖRSELLER */}
        <div className="absolute inset-0 bg-slate-900">
          <img
            src={isEnglishPage 
              ? "https://ajancnc.com/wp-content/uploads/2025/12/ajanlaser-1.png"
              : "https://files.ajancnc.com/wp-content/uploads/2025/12/ajan-lazer-1.png"
            }
            alt={isEnglishPage ? "AJAN Fiber Laser Cutting Machine" : "AJAN Fiber Lazer Kesim Makinesi"}
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-contain object-right opacity-0 md:opacity-100"
            style={{
              filter: 'contrast(1.25) brightness(1.08) saturate(1.15)',
            }}
          />
          {/* Hafif Noise Texture */}
          <div 
            className="absolute inset-0 opacity-[0.03]"
            style={{
              backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' /%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\' /%3E%3C/svg%3E")',
              backgroundRepeat: 'repeat',
            }}
          ></div>
        </div>

        {/* Sol Kenar - Metin Alanı */}
        <div className="absolute inset-y-0 left-0 w-full md:max-w-2xl">
          {/* İçerik */}
          <div className="relative h-full flex flex-col justify-center px-6 sm:px-8 lg:px-16 pt-32 md:pt-40">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/15 backdrop-blur-md border border-white/30 rounded-full mb-4 sm:mb-6 w-fit">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-xs sm:text-sm text-white font-bold tracking-wide">
                {isEnglish ? 'Domestic Production • Global Standards' : 'Yerli Üretim • Global Standartlar'}
              </span>
            </div>

            {/* Ana Başlık - TEK H1 */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-[1.3] mb-4 sm:mb-6">
              <span className="block text-white drop-shadow-2xl">
                {isEnglish ? 'Fiber' : 'Fiber'}
              </span>
              <span className="block text-white drop-shadow-2xl">
                <span className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-[1.3] mb-4 sm:mb-6">
                  {isEnglish ? 'Laser' : 'Lazer'}
                </span>
              </span>
              <span className="block text-white drop-shadow-2xl">
                {isEnglish ? 'Cutting Systems' : 'Kesim Sistemleri'}
              </span>
            </h1>

            {/* Açıklama */}
            <p className="text-base sm:text-lg lg:text-[22px] text-white/95 leading-relaxed mb-6 sm:mb-8 drop-shadow-lg max-w-lg">
              {isEnglish 
                ? 'Safe and high-performance fiber laser cutting solutions developed by AJAN LASER, suitable for serial production.'
                : 'AJAN Lazer tarafından geliştirilen, seri üretime uygun, güvenli ve yüksek performanslı fiber lazer kesim çözümleri.'}
            </p>

            {/* CTA Butonları */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-10">
              <button
                onClick={() => {
                  const ctaSection = document.getElementById('cta-section');
                  if (ctaSection) {
                    const yOffset = -80;
                    const y = ctaSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                  } else {
                    window.REACT_APP_NAVIGATE(isEnglish ? '/en' : '/');
                    setTimeout(() => {
                      const ctaElement = document.getElementById('cta-section');
                      if (ctaElement) {
                        const yOffset = -80;
                        const y = ctaElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                      }
                    }, 100);
                  }
                }}
                className="group px-6 sm:px-8 py-3 sm:py-4 bg-red-600 text-white font-bold text-base sm:text-lg rounded-xl transition-all duration-300 hover:bg-red-700 hover:shadow-2xl hover:shadow-red-600/50 whitespace-nowrap"
              >
                <span className="flex items-center justify-center gap-2">
                  {isEnglish ? 'Get Quote' : 'Teklif Al'}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </button>

              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE(isEnglish ? '/en/products/kapali-kabin' : '/products/kapali-kabin');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-md border-2 border-white/50 text-white font-bold text-base sm:text-lg rounded-xl transition-all duration-300 hover:bg-white hover:text-slate-950 whitespace-nowrap"
              >
                {isEnglish ? 'Explore Products' : 'Ürünleri İncele'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Ürünlerimiz Bölümü */}
      <section className="py-20 bg-[#F9FAFB] px-8 lg:px-16">
        <div className="mx-auto max-w-7xl">
          {/* Başlık Alanı */}
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-[#1F2937] mb-6">
              {isEnglish ? 'Our Products' : 'Ürünlerimiz'}
            </h2>
            <div className="w-24 h-1 bg-[#D62828] mx-auto mb-6"></div>
            <p className="text-2xl text-[#4B5563]">
              {isEnglish 
                ? 'Comprehensive solutions for industrial laser cutting'
                : 'Endüstriyel lazer kesim için kapsamlı çözümler'}
            </p>
          </div>

          {/* Product Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* Kapalı Kabin */}
            <Link
              to={isEnglishPage ? '/en/products/kapali-kabin' : '/products/kapali-kabin'}
              onClick={() => {
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'instant' });
                }, 0);
              }}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer hover:-translate-y-2 flex flex-col"
            >
              <div className="relative h-80 overflow-hidden bg-gray-50">
                <img
                  src="https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/48db2d4eadb135f04b847468fe9d54fe.jpeg"
                  alt={isEnglishPage ? 'Fully Enclosed Fiber Laser' : 'Kapalı Kabin Fiber Lazer'}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-3 group-hover:text-[#D62828] transition-colors">
                  {isEnglishPage ? 'Fully Enclosed Fiber Laser' : 'Kapalı Kabin Fiber Lazer'}
                </h3>
                <p className="text-[19px] text-gray-600 mb-6">
                  {isEnglishPage 
                    ? 'Compact design and high safety standards'
                    : 'Kompakt tasarım ve yüksek güvenlik standartları'}
                </p>
                <div className="flex items-center text-[#D62828] font-semibold text-[19px] mt-auto">
                  {isEnglishPage ? 'View Details' : 'Detayları Gör'}
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Gezer Kabin */}
            <Link
              to={isEnglishPage ? '/en/products/gezer-kabin' : '/products/gezer-kabin'}
              onClick={() => {
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'instant' });
                }, 0);
              }}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer hover:-translate-y-2 flex flex-col"
            >
              <div className="relative h-80 overflow-hidden bg-gray-50">
                <img
                  src="https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/87536d91e938e8feb153e654c7ee1710.png"
                  alt={isEnglishPage ? 'Enclosed Gantry Fiber Laser' : 'Gezer Kabin Fiber Lazer'}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-3 group-hover:text-[#D62828] transition-colors">
                  {isEnglishPage ? 'Enclosed Gantry Fiber Laser' : 'Gezer Kabin Fiber Lazer'}
                </h3>
                <p className="text-[19px] text-gray-600 mb-6">
                  {isEnglishPage 
                    ? 'Advanced systems for large sheet cutting'
                    : 'Büyük ebatlı levha işleme kapasitesi'}
                </p>
                <div className="flex items-center text-[#D62828] font-semibold text-[19px] mt-auto">
                  {isEnglishPage ? 'View Details' : 'Detayları Gör'}
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Boru ve Profil */}
            <Link
              to={isEnglishPage ? '/en/products/boru-profil-kesim' : '/products/boru-profil-kesim'}
              onClick={() => {
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'instant' });
                }, 0);
              }}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer hover:-translate-y-2 flex flex-col"
            >
              <div className="relative h-80 overflow-hidden bg-gray-50">
                <img
                  src="https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/f498853daf2316de5fdcd5614fb9835f.png"
                  alt={isEnglishPage ? 'Tube and Profile Fiber Laser' : 'Boru ve Profil Fiber Lazer'}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-3 group-hover:text-[#D62828] transition-colors">
                  {isEnglishPage ? 'Tube and Profile Fiber Laser' : 'Boru ve Profil Fiber Lazer'}
                </h3>
                <p className="text-[19px] text-gray-600 mb-6">
                  {isEnglishPage 
                    ? 'Advanced systems for tube and profile cutting'
                    : 'Çoklu boru ve profil kesimi için özel tasarım'}
                </p>
                <div className="flex items-center text-[#D62828] font-semibold text-[19px] mt-auto">
                  {isEnglishPage ? 'View Details' : 'Detayları Gör'}
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Application Areas Section - Ürünlerimiz'in hemen altına taşındı */}
      <section className="py-16 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              {t('app.title')}
            </h2>
            <div className="w-24 h-1 bg-[#D62828] mx-auto mb-6"></div>
            <p className="text-[22px] text-gray-600 max-w-3xl mx-auto">
              {isEnglish 
                ? 'Perform high-precision cutting operations on various metal materials with AJAN LASER fiber laser cutting machines'
                : 'AJAN LAZER fiber lazer kesim makineleri ile çeşitli metal malzemelerde yüksek hassasiyetli kesim işlemleri gerçekleştirin'}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/ddd585aaaf535e30d3a19b61864a769f.jpg"
                  alt="Alüminyum fiber lazer kesim"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-gray-900 text-xl">{t('app.aluminum')}</h3>
                <p className="text-base text-gray-600 mt-1">{t('app.aluminumDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20view%20of%20dark%20carbon%20steel%20metal%20plate%20surface%20with%20natural%20metallic%20texture%20and%20matte%20finish%2C%20industrial%20grade%20steel%20material%20showing%20authentic%20surface%20characteristics%2C%20simple%20neutral%20background%20highlighting%20the%20carbon%20steel%20material%20properties%20and%20quality&width=400&height=400&seq=carbon-steel-material-001&orientation=squarish"
                  alt="Karbon çeliği fiber lazer kesim"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-gray-900 text-xl">{t('app.carbonSteel')}</h3>
                <p className="text-base text-gray-600 mt-1">{t('app.carbonSteelDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20view%20of%20brass%20metal%20sheet%20surface%20with%20natural%20golden%20yellow%20shine%20and%20smooth%20finish%2C%20polished%20brass%20material%20texture%20showing%20authentic%20metallic%20luster%2C%20simple%20neutral%20background%20highlighting%20the%20brass%20material%20properties%20and%20surface%20quality&width=400&height=400&seq=brass-material-001&orientation=squarish"
                  alt="Pirinç fiber lazer kesim"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-gray-900 text-xl">{t('app.brass')}</h3>
                <p className="text-base text-gray-600 mt-1">{t('app.brassDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20view%20of%20stainless%20steel%20metal%20plate%20surface%20with%20bright%20reflective%20mirror-like%20finish%20and%20natural%20metallic%20shine%2C%20polished%20industrial%20grade%20steel%20material%20texture%2C%20simple%20neutral%20background%20highlighting%20the%20stainless%20steel%20material%20properties%20and%20premium%20quality&width=400&height=400&seq=stainless-steel-material-001&orientation=squarish"
                  alt="Paslanmaz çelik fiber lazer kesim"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-gray-900 text-xl">{t('app.stainlessSteel')}</h3>
                <p className="text-base text-gray-600 mt-1">{t('app.stainlessSteelDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20view%20of%20various%20metal%20sheets%20and%20plates%20including%20copper%20bronze%20and%20galvanized%20steel%20surfaces%20with%20different%20metallic%20textures%20and%20finishes%2C%20industrial%20grade%20metal%20materials%20showing%20authentic%20surface%20characteristics%2C%20simple%20neutral%20background%20highlighting%20the%20diverse%20metal%20material%20properties%20and%20quality&width=400&height=400&seq=various-metal-material-001&orientation=squarish"
                  alt="Çeşitli metal fiber lazer kesim"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-gray-900 text-xl">{t('app.otherMetals')}</h3>
                <p className="text-base text-gray-600 mt-1">{t('app.otherMetalsDesc')}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
              {t('app.materialsTitle')}
            </h3>
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
              <p className="mb-4 text-base">
                {t('app.materialsDesc1')}
              </p>
              <p className="mb-4 text-base">
                {t('app.materialsDesc2')}
              </p>
              <p className="text-base">
                {t('app.materialsDesc3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Yeni Güven ve Başarı Bölümü */}
          <div className="mb-16">
            <div className="bg-gradient-to-br from-white via-gray-50 to-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid lg:grid-cols-2 gap-0">
                {/* Sol Taraf - İçerik */}
                <div className="p-8 lg:p-12 flex flex-col justify-center px-8">
                  <div className="inline-block mb-4">
                    <span className="bg-[#D62828]/10 text-[#D62828] px-4 py-2 rounded-full text-base font-semibold">
                      {t('trust.badge')}
                    </span>
                  </div>
                  <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                    {t('trust.title')}
                  </h2>
                  <p className="text-[22px] text-gray-600 leading-relaxed mb-8">
                    {t('trust.description')}
                  </p>
                  
                  {/* İstatistikler - Schema.org ile işaretlenmiş */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-6" itemScope itemType="https://schema.org/Organization">
                    <div className="text-center" itemProp="foundingDate" content="1973">
                      <div className="text-5xl font-bold text-[#D62828] mb-2" itemProp="yearsInOperation">50+</div>
                      <div className="text-base text-gray-600 font-medium">{t('trust.experience')}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-5xl font-bold text-[#D62828] mb-2">6000+</div>
                      <div className="text-base text-gray-600 font-medium">{t('trust.machines')}</div>
                    </div>
                    <div className="text-center" itemProp="areaServed" itemScope itemType="https://schema.org/Place">
                      <div className="text-5xl font-bold text-[#D62828] mb-2">70+</div>
                      <div className="text-base text-gray-600 font-medium">{t('trust.countries')}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-5xl font-bold text-[#D62828] mb-2">15</div>
                      <div className="text-base text-gray-600 font-medium">{t('trust.laserRD')}</div>
                    </div>
                  </div>
                </div>

                {/* Sağ Taraf - Özellik Kartları */}
                <div className="bg-gradient-to-br from-[#D62828] to-[#B91C1C] p-8 lg:p-12 flex items-center">
                  <div className="grid gap-6 w-full">
                    <div className="bg-white/95 backdrop-blur rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-[#D62828] rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-shield-star-line text-white text-[22px]"></i>
                        </div>
                        <div>
                          <h3 className="text-[22px] font-bold text-gray-900 mb-2">
                            {t('trust.leadership')}
                          </h3>
                          <p className="text-gray-600 text-base leading-relaxed">
                            {t('trust.leadershipDesc')}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white/95 backdrop-blur rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-[#D62828] rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-team-line text-white text-[22px]"></i>
                        </div>
                        <div>
                          <h3 className="text-[22px] font-bold text-gray-900 mb-2">
                            {t('trust.deepRoots')}
                          </h3>
                          <p className="text-gray-600 text-base leading-relaxed">
                            {t('trust.deepRootsDesc')}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white/95 backdrop-blur rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-[#D62828] rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-global-line text-white text-[22px]"></i>
                        </div>
                        <div>
                          <h3 className="text-[22px] font-bold text-gray-900 mb-2">
                            {t('trust.rdPeak')}
                          </h3>
                          <p className="text-gray-600 text-base leading-relaxed">
                            {t('trust.rdPeakDesc')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-8 bg-gradient-to-r from-white to-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              <div className="flex-1">
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                  {t('cert.title')}
                </h2>
                <p className="text-base text-gray-600 leading-relaxed">
                  {t('cert.description')}
                </p>
              </div>
              <div className="flex flex-wrap justify-center gap-6">
                <div className="flex flex-col items-center gap-2 bg-gray-50 rounded-lg p-6 min-w-[140px]">
                  <i className="ri-award-fill text-[#D62828] text-3xl"></i>
                  <span className="font-bold text-base text-gray-900">{t('cert.ce')}</span>
                  <span className="text-sm text-gray-600 text-center">{t('cert.ceDesc')}</span>
                </div>
                <div className="flex flex-col items-center gap-2 bg-gray-50 rounded-lg p-6 min-w-[140px]">
                  <i className="ri-shield-star-fill text-[#D62828] text-3xl"></i>
                  <span className="font-bold text-base text-gray-900">{t('cert.iso12100')}</span>
                  <span className="text-sm text-gray-600 text-center">{t('cert.iso12100Desc')}</span>
                </div>
                <div className="flex flex-col items-center gap-2 bg-gray-50 rounded-lg p-6 min-w-[140px]">
                  <i className="ri-flashlight-fill text-[#D62828] text-3xl"></i>
                  <span className="font-bold text-base text-gray-900">{t('cert.iso60204')}</span>
                  <span className="text-sm text-gray-600 text-center">{t('cert.iso60204Desc')}</span>
                </div>
                <div className="flex flex-col items-center gap-2 bg-gray-50 rounded-lg p-6 min-w-[140px]">
                  <i className="ri-plug-fill text-[#D62828] text-3xl"></i>
                  <span className="font-bold text-base text-gray-900">{t('cert.iso60974')}</span>
                  <span className="text-sm text-gray-600 text-center">{t('cert.iso60974Desc')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* After Sales Service Section */}
      <section className="py-16 bg-gradient-to-br from-gray-50 via-white to-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              {t('service.title')}
            </h2>
            <div className="w-24 h-1 bg-[#D62828] mx-auto mb-6"></div>
            <p className="text-[22px] text-gray-600 max-w-3xl mx-auto">
              {t('service.subtitle')}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-8">
            {/* Sol Taraf - Görsel */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#D62828]/20 to-transparent z-10"></div>
                <img 
                  src="https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/c49ef897f17f6c8c5c34312d0588071f.png"
                  alt="Satış sonrası servis ve teknik destek"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#D62828]/10 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl"></div>
            </div>

            {/* Sağ Taraf - Açıklamalar */}
            <div className="flex flex-col justify-center space-y-6">
              {/* Warranty Info */}
              <div className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-[#D62828]">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D62828] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-fill text-white text-[22px]"></i>
                  </div>
                  <div>
                    <h3 className="text-[22px] font-bold text-gray-900 mb-2">
                      {t('service.warranty')}
                    </h3>
                    <p className="text-base text-gray-600 leading-relaxed">
                      {t('service.warrantyDesc')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Warranty Exclusions */}
              <div className="bg-amber-50 rounded-2xl shadow-lg p-6 border-l-4 border-amber-500">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-fill text-white text-[22px]"></i>
                  </div>
                  <div>
                    <h3 className="text-[22px] font-bold text-gray-900 mb-2">
                      {t('service.exclusions')}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t('service.exclusionsDesc')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Service Features */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white rounded-xl shadow-md p-4 text-center hover:shadow-lg transition-all">
                  <div className="w-10 h-10 bg-[#D62828]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <i className="ri-customer-service-2-fill text-[#D62828] text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-base">{t('service.technicalSupport')}</h4>
                </div>
                <div className="bg-white rounded-xl shadow-md p-4 text-center hover:shadow-lg transition-all">
                  <div className="w-10 h-10 bg-[#D62828]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <i className="ri-truck-fill text-[#D62828] text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-base">{t('service.fastService')}</h4>
                </div>
                <div className="bg-white rounded-xl shadow-md p-4 text-center hover:shadow-lg transition-all">
                  <div className="w-10 h-10 bg-[#D62828]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <i className="ri-tools-fill text-[#D62828] text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-base">{t('service.spareParts')}</h4>
                </div>
                <div className="bg-white rounded-xl shadow-md p-4 text-center hover:shadow-lg transition-all">
                  <div className="w-10 h-10 bg-[#D62828]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <i className="ri-team-fill text-[#D62828] text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-base">{t('service.expertTeam')}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-12 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              {t('why.title')}
            </h2>
            <div className="w-24 h-1 bg-[#D62828] mx-auto mb-8"></div>
            <p className="text-[22px] text-gray-600 max-w-2xl mx-auto">
              {t('why.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {whyChooseUs.map((item, index) => (
              <div 
                key={index}
                className="flex gap-4 p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-all hover:-translate-y-1"
              >
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-[#D62828]/10 rounded-lg flex items-center justify-center">
                    <i className="ri-check-line text-[#D62828] text-lg"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-[22px] font-semibold text-gray-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="cta-section" className="py-8 bg-gradient-to-r from-[#D62828] to-[#B91C1C] text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-2xl mb-6 text-white/90 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={isEnglish ? "tel:+904442526" : "tel:4442526"}
              className="px-8 py-4 bg-white text-[#D62828] font-semibold text-lg rounded-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              {t('cta.callNow')}
            </a>

            <Link
              to="/katalog"
              onClick={handleCatalogClick}
              className="px-8 py-4 bg-transparent border-2 border-white/50 text-white font-semibold text-lg rounded-lg hover:bg-white hover:text-slate-950 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2"></i>
              {t('cta.viewCatalogs')}
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="teklif-al" className="py-8 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">{t('form.title')}</h2>
            <p className="text-[22px] text-gray-600">
              {t('form.subtitle')}
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <form 
              id="teklif-formu"
              data-readdy-form
              onSubmit={handleSubmit} 
              className="space-y-5"
            >
              {/* Honeypot field - spam botları için */}
              <input
                type="text"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
                aria-hidden="true"
              />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="company" className="block text-base font-medium text-gray-700 mb-1">
                    {t('form.companyName')}
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleFormChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base"
                    placeholder={t('form.companyNamePlaceholder')}
                  />
                </div>

                <div>
                  <label htmlFor="name" className="block text-base font-medium text-gray-700 mb-1">
                    {t('form.fullName')}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base"
                    placeholder={t('form.fullNamePlaceholder')}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="email" className="block text-base font-medium text-gray-700 mb-1">
                    {t('form.email')}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base"
                    placeholder={t('form.emailPlaceholder')}
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-base font-medium text-gray-700 mb-1">
                    {t('form.phone')}
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleFormChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base"
                    placeholder={t('form.phonePlaceholder')}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="address" className="block text-base font-medium text-gray-700 mb-1">
                  {t('form.address')}
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleFormChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base"
                  placeholder={t('form.addressPlaceholder')}
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-base font-medium text-gray-700 mb-1">
                  {t('form.message')} *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    handleFormChange(e);
                    if (messageError) setMessageError('');
                  }}
                  required
                  minLength={10}
                  maxLength={500}
                  rows={4}
                  className={`w-full px-4 py-3 border ${messageError ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-[#D62828] focus:border-transparent text-base resize-none`}
                  placeholder={t('form.messagePlaceholder')}
                ></textarea>
                {messageError && (
                  <div className="text-red-600 text-sm mt-1 flex items-center gap-1">
                    <i className="ri-error-warning-line"></i>
                    {messageError}
                  </div>
                )}
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.message.length}/500 {t('form.characters')}
                </div>
              </div>

              {formStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-check-line text-lg"></i>
                    <span className="font-medium text-base">{t('form.success')}</span>
                  </div>
                </div>
              )}

              {formStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-error-warning-line text-lg"></i>
                    <span className="font-medium text-base">
                      {formData.message.length > 500 
                        ? (isEnglish ? 'Message cannot exceed 500 characters. Please shorten your message.' : 'Mesaj 500 karakteri geçemez. Lütfen mesajınızı kısaltın.')
                        : t('form.error')
                      }
                    </span>
                  </div>
                </div>
              )}

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full bg-[#D62828] text-white font-semibold text-lg py-4 px-6 rounded-lg hover:bg-[#B91C1C] transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {formStatus === 'submitting' ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    {t('form.submitting')}
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-send-plane-fill"></i>
                    {t('form.submit')}
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-[#D62828] text-white rounded-full shadow-lg hover:bg-[#B91C1C] transition-all duration-300 hover:scale-110 z-50 flex items-center justify-center cursor-pointer"
          aria-label="Yukarı Çık"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}
